module.exports = __webpack_public_path__ + "img/chinesecompany211.4bdc4c1a.png";